import React, { useState } from 'react';
import { User2Icon, CreditCardIcon, BellIcon, ShieldIcon, KeyIcon, UserIcon, SmileIcon, CatIcon, DogIcon, BirdIcon, ChevronRightIcon, BarChart3Icon, ClockIcon, StarIcon, BoxIcon, AwardIcon, ZapIcon, BrainIcon } from 'lucide-react';
import { mockApps } from '../utils/mockData';
import { useNavigate } from 'react-router-dom';
const avatarOptions = [{
  icon: <UserIcon className="h-6 w-6" data-id="element-1079" />,
  name: 'Default'
}, {
  icon: <SmileIcon className="h-6 w-6" data-id="element-1080" />,
  name: 'Smile'
}, {
  icon: <CatIcon className="h-6 w-6" data-id="element-1081" />,
  name: 'Cat'
}, {
  icon: <DogIcon className="h-6 w-6" data-id="element-1082" />,
  name: 'Dog'
}, {
  icon: <BirdIcon className="h-6 w-6" data-id="element-1083" />,
  name: 'Bird'
}];
const subscriptionTiers = [{
  name: 'Free',
  price: '$0',
  current: true,
  features: ['10 Created AI Apps', '2,000 Monthly Credits', 'Basic Support', 'Community Access']
}, {
  name: 'Pro',
  price: '$9.99/mo',
  current: false,
  features: ['Unlimited Created Apps', '50,000 Monthly Credits', 'Priority Support', 'API Access', 'No Ads']
}, {
  name: 'Enterprise',
  price: 'Custom',
  current: false,
  features: ['Custom AI Models', 'Unlimited Credits', 'Dedicated Support', 'Team Management', 'Custom Integration']
}];
export const MyAccount = () => {
  const navigate = useNavigate();
  const [selectedAvatar, setSelectedAvatar] = useState(0);
  // Calculate mock statistics
  const totalApps = mockApps.length;
  const totalUsage = '234'; // This would come from real usage data
  const avgRating = 4.8;
  const StatCard = ({
    icon: Icon,
    label,
    value
  }: any) => <div className="bg-white p-6 rounded-lg border border-gray-200" data-id="element-1084">
      <div className="flex items-center justify-between mb-4" data-id="element-1085">
        <div className="text-gray-500" data-id="element-1086">{label}</div>
        <Icon className="h-5 w-5 text-gray-400" data-id="element-1087" />
      </div>
      <div className="text-2xl font-semibold" data-id="element-1088">{value}</div>
    </div>;
  return <div className="min-h-screen bg-gray-50 py-8 px-4 sm:px-6 lg:px-8" data-id="element-1089">
      <div className="max-w-4xl mx-auto space-y-8" data-id="element-1090">
        {/* Badges Section */}
        <div className="bg-white rounded-lg border border-gray-200 overflow-hidden" data-id="element-1091">
          <div className="px-6 py-8" data-id="element-1092">
            <h2 className="text-2xl font-bold mb-6" data-id="element-1093">My Badges</h2>
            <div className="flex flex-wrap gap-4" data-id="element-1094">
              <div className="flex items-center space-x-3 bg-indigo-50 border border-indigo-200 rounded-full px-4 py-2" data-id="element-1095">
                <AwardIcon className="h-5 w-5 text-indigo-600" data-id="element-1096" />
                <span className="text-indigo-700 font-medium" data-id="element-1097">Developer</span>
              </div>
              <div className="flex items-center space-x-3 bg-purple-50 border border-purple-200 rounded-full px-4 py-2" data-id="element-1098">
                <ZapIcon className="h-5 w-5 text-purple-600" data-id="element-1099" />
                <span className="text-purple-700 font-medium" data-id="element-1100">
                  Early Adopter
                </span>
              </div>
              <div className="flex items-center space-x-3 bg-green-50 border border-green-200 rounded-full px-4 py-2" data-id="element-1101">
                <BrainIcon className="h-5 w-5 text-green-600" data-id="element-1102" />
                <span className="text-green-700 font-medium" data-id="element-1103">Super Nerd</span>
              </div>
            </div>
          </div>
        </div>
        {/* Credits Usage Section */}
        <div className="bg-white rounded-lg border border-gray-200 overflow-hidden" data-id="element-1104">
          <div className="px-6 py-8" data-id="element-1105">
            <h2 className="text-2xl font-bold mb-6" data-id="element-1106">Credits</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1107">
              <div className="p-6 border border-gray-200 rounded-lg" data-id="element-1108">
                <div className="flex justify-between items-center mb-4" data-id="element-1109">
                  <span className="text-gray-600" data-id="element-1110">Available Credits</span>
                  <ZapIcon className="h-5 w-5 text-amber-500" data-id="element-1111" />
                </div>
                <div className="text-3xl font-bold" data-id="element-1112">1,459</div>
                <div className="text-sm text-gray-500 mt-2" data-id="element-1113">
                  Resets in 12 days
                </div>
              </div>
              <div className="p-6 border border-gray-200 rounded-lg" data-id="element-1114">
                <div className="flex justify-between items-center mb-4" data-id="element-1115">
                  <span className="text-gray-600" data-id="element-1116">Used This Month</span>
                  <BarChart3Icon className="h-5 w-5 text-indigo-500" data-id="element-1117" />
                </div>
                <div className="text-3xl font-bold" data-id="element-1118">541</div>
                <div className="text-sm text-gray-500 mt-2" data-id="element-1119">
                  of 2,000 monthly credits
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Profile Section */}
        <div className="bg-white rounded-lg border border-gray-200 overflow-hidden" data-id="element-1120">
          <div className="px-6 py-8" data-id="element-1121">
            <h2 className="text-2xl font-bold mb-6" data-id="element-1122">My Profile</h2>
            <div className="flex flex-col sm:flex-row items-start gap-8" data-id="element-1123">
              <div className="w-full sm:w-64" data-id="element-1124">
                <div className="mb-4" data-id="element-1125">
                  <div className={`w-32 h-32 rounded-full bg-indigo-100 flex items-center justify-center mb-4`} data-id="element-1126">
                    {avatarOptions[selectedAvatar].icon}
                  </div>
                  <button className="text-sm text-indigo-600 hover:text-indigo-700" data-id="element-1127">
                    Change Avatar
                  </button>
                </div>
                <div className="grid grid-cols-5 gap-2" data-id="element-1128">
                  {avatarOptions.map((option, index) => <button key={index} className={`p-2 rounded-lg border ${selectedAvatar === index ? 'border-indigo-600 bg-indigo-50' : 'border-gray-200 hover:border-indigo-600'}`} onClick={() => setSelectedAvatar(index)} data-id="element-1129">
                      {option.icon}
                    </button>)}
                </div>
              </div>
              <div className="flex-1 w-full" data-id="element-1130">
                <div className="space-y-4" data-id="element-1131">
                  <div data-id="element-1132">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1133">
                      Display Name
                    </label>
                    <input type="text" defaultValue="John Doe" className="w-full border-gray-200 rounded-md px-4 py-2" data-id="element-1134" />
                  </div>
                  <div data-id="element-1135">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1136">
                      Email
                    </label>
                    <input type="email" defaultValue="john@example.com" className="w-full border-gray-200 rounded-md px-4 py-2" data-id="element-1137" />
                  </div>
                  <div data-id="element-1138">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1139">
                      Bio
                    </label>
                    <textarea className="w-full border-gray-200 rounded-md px-4 py-2" rows={3} defaultValue="AI enthusiast and developer" data-id="element-1140" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Dashboard Section */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1141">
          <StatCard icon={BoxIcon} label="Total Apps" value={totalApps} data-id="element-1142" />
          <StatCard icon={ClockIcon} label="Total Usage" value={`${totalUsage}h`} data-id="element-1143" />
          <StatCard icon={StarIcon} label="Avg. Rating" value={avgRating} data-id="element-1144" />
        </div>
        {/* Subscription Section */}
        <div className="bg-white rounded-lg border border-gray-200 overflow-hidden" data-id="element-1145">
          <div className="px-6 py-8" data-id="element-1146">
            <h2 className="text-2xl font-bold mb-6" data-id="element-1147">Subscription</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1148">
              {subscriptionTiers.map(tier => <div key={tier.name} className={`rounded-lg border ${tier.current ? 'border-indigo-600 bg-indigo-50' : 'border-gray-200'} p-6`} data-id="element-1149">
                  <h3 className="text-lg font-semibold mb-2" data-id="element-1150">{tier.name}</h3>
                  <p className="text-2xl font-bold mb-4" data-id="element-1151">{tier.price}</p>
                  <ul className="space-y-2 mb-6" data-id="element-1152">
                    {tier.features.map(feature => <li key={feature} className="flex items-center text-sm" data-id="element-1153">
                        <ChevronRightIcon className="h-4 w-4 text-indigo-600 mr-2" data-id="element-1154" />
                        {feature}
                      </li>)}
                  </ul>
                  <button className={`w-full py-2 rounded-md ${tier.current ? 'bg-indigo-600 text-white' : 'border border-indigo-600 text-indigo-600'}`} data-id="element-1155">
                    {tier.current ? 'Current Plan' : 'Upgrade'}
                  </button>
                </div>)}
            </div>
          </div>
        </div>
        {/* Settings Section */}
        <div className="bg-white rounded-lg border border-gray-200 overflow-hidden" data-id="element-1156">
          <div className="px-6 py-8" data-id="element-1157">
            <h2 className="text-2xl font-bold mb-6" data-id="element-1158">Settings</h2>
            <div className="space-y-4" data-id="element-1159">
              <button onClick={() => navigate('/settings')} className="w-full flex items-center justify-between p-4 rounded-lg border border-gray-200 hover:border-indigo-600 group" data-id="element-1160">
                <div className="flex items-center" data-id="element-1161">
                  <BellIcon className="h-5 w-5 text-gray-400 group-hover:text-indigo-600 mr-3" data-id="element-1162" />
                  <span data-id="element-1163">Notifications</span>
                </div>
                <ChevronRightIcon className="h-5 w-5 text-gray-400" data-id="element-1164" />
              </button>
              <button onClick={() => navigate('/settings')} className="w-full flex items-center justify-between p-4 rounded-lg border border-gray-200 hover:border-indigo-600 group" data-id="element-1165">
                <div className="flex items-center" data-id="element-1166">
                  <ShieldIcon className="h-5 w-5 text-gray-400 group-hover:text-indigo-600 mr-3" data-id="element-1167" />
                  <span data-id="element-1168">Privacy</span>
                </div>
                <ChevronRightIcon className="h-5 w-5 text-gray-400" data-id="element-1169" />
              </button>
              <button onClick={() => navigate('/settings')} className="w-full flex items-center justify-between p-4 rounded-lg border border-gray-200 hover:border-indigo-600 group" data-id="element-1170">
                <div className="flex items-center" data-id="element-1171">
                  <KeyIcon className="h-5 w-5 text-gray-400 group-hover:text-indigo-600 mr-3" data-id="element-1172" />
                  <span data-id="element-1173">Security</span>
                </div>
                <ChevronRightIcon className="h-5 w-5 text-gray-400" data-id="element-1174" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>;
};